export function Loader() {
	return (
		<div className="flex h-screen w-full items-center justify-center p-4">
			<div
				className="size-10 rounded-full border-4 border-muted border-t-foreground animate-spin dark:border-muted dark:border-t-foreground"
				suppressHydrationWarning
			>
				<span className="sr-only">Loading...</span>
			</div>
		</div>
	);
}
